import styled from "styled-components";

const Container = styled.div`
    display: flex;
    align-items: center;
    >div.trashScreenLink{
        display: none;
        transition: 200ms ease;
    }
    &:hover{
        >div.trashScreenLink{
            display:flex;
        }
    }
`;

export default Container;
